import React, { useState } from 'react';
import {DownloadIcon, LoadingIcon } from "../assets/icons/Icons";

const ExportDataButton = (props) => {

    const [loading , setLoading] = useState();
    const onClick = async () => {
        setLoading(true);
        if (props.onClick) {
            await props.onClick();
        }
        setLoading(false);
    }
    return (
        <button onClick={onClick} className={`${props.className} ${loading ? 'btn-loading' : ''}`} disabled={loading ||props.disabled}>
            {loading ? <LoadingIcon/> : <DownloadIcon/>}
            {props.label}
        </button>
    );
};

export default ExportDataButton;
